import { protectedAxios } from "@shared/src/utils/axios";
import { handleServiceError } from "@shared/src/utils/error-handler";
import {
  ClaimGoldBarsResponse,
  GoldBarsReferral,
  GoldBarsResponse,
  LeaderboardResponse,
} from "@sdk/shared/types/goldbars.types";

export const goldBarsService = {
  getLeaderboard: async () => {
    return handleServiceError(async () => {
      const { data } = await protectedAxios.get<LeaderboardResponse>("/auth/leaderboard");
      if (!data) {
        throw new Error("Failed to fetch Leaderboard data");
      }
      return data;
    });
  },
  getGoldBars: async () => {
    return handleServiceError(async () => {
      const { data } = await protectedAxios.get<GoldBarsResponse>("/auth/bars");
      if (!data) {
        throw new Error("Failed to fetch Gold Bars data");
      }
      return data;
    });
  },
  claimGoldBars: async () => {
    return handleServiceError(async () => {
      const { data } = await protectedAxios.post<ClaimGoldBarsResponse>("/auth/bars/claim");
      if (!data) {
        throw new Error("Failed to claim Gold Bars");
      }
      return data;
    });
  },
  referUser: async (referrer: string) => {
    return handleServiceError(async () => {
      const { data } = await protectedAxios.post<GoldBarsReferral>("/auth/refer", { referrer });
      if (!data) {
        throw new Error("Failed to refer user");
      }
      return data;
    });
  },
};
